import * as React from 'react';

export type TableBodyProps = React.ComponentPropsWithoutRef<'tbody'> & {
  variant?: 'default' | 'alternate';
  className?: string;
  rightColTextAlign?: 'left' | 'right';
};
